import React, { useState, useEffect } from 'react';
import '../assets/styles/CadastroProdutor.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function CadastroRegiaoCultura() {
  const [regiao, setRegiao] = useState({ nome: '' });
  const [cultura, setCultura] = useState({ nome: '' });
  const [regioes, setRegioes] = useState([]);
  const [culturas, setCulturas] = useState([]);
  const [editRegiaoId, setEditRegiaoId] = useState(null);
  const [regiaoEdit, setRegiaoEdit] = useState(null);
  const [editCulturaId, setEditCulturaId] = useState(null);
  const [culturaEdit, setCulturaEdit] = useState(null);
  const [mensagemRegiao, setMensagemRegiao] = useState(null);
  const [mensagemCultura, setMensagemCultura] = useState(null);

  // Carregar regiões da API ao inicializar
  useEffect(() => {
    fetch(`${API_BASE_URL}/regioes/`)
      .then(res => res.json())
      .then(data => {
        console.log('Regiões carregadas:', data);
        setRegioes(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagemRegiao('❌ Erro ao carregar regiões.'));
  }, []);

  // Carregar culturas da API ao inicializar
  useEffect(() => {
    fetch(`${API_BASE_URL}/culturas/`)
      .then(res => res.json())
      .then(data => {
        console.log('Culturas carregadas:', data);
        setCulturas(Array.isArray(data.productId) ? data.productId : []);
      })
      .catch(() => setMensagemCultura('❌ Erro ao carregar culturas.'));
  }, []);

  const handleRegiaoChange = e => {
    setRegiao({ ...regiao, [e.target.name]: e.target.value });
  };
  const handleCulturaChange = e => {
    setCultura({ ...cultura, [e.target.name]: e.target.value });
  };

  const handleRegiaoSubmit = async (e) => {
    e.preventDefault();
    
    if (editRegiaoId) {
      // Atualizar região existente
      try {
        const res = await fetch(`${API_BASE_URL}/regioes/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editRegiaoId,
            nome: regiao.nome
          })
        });
        if (res.ok) {
          setRegioes(regioes.map(r => (r.id === editRegiaoId ? { ...r, nome: regiao.nome } : r)));
          setMensagemRegiao('✅ Região atualizada com sucesso!');
          setEditRegiaoId(null);
        } else {
          setMensagemRegiao('❌ Erro ao atualizar região.');
        }
      } catch {
        setMensagemRegiao('❌ Erro ao atualizar região.');
      }
    } else {
      // Criar nova região
      try {
        const res = await fetch(`${API_BASE_URL}/regioes/add`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nome: regiao.nome
          })
        });
        if (res.ok) {
          const result = await res.json();
          // Buscar a região recém cadastrada pelo id retornado
          if (result && result.productId) {
            const resRegiao = await fetch(`${API_BASE_URL}/regioes/${result.productId}`);
            const regiaoData = await resRegiao.json();
            if (regiaoData && Array.isArray(regiaoData.regioes) && regiaoData.regioes.length > 0) {
              setRegioes([...regioes, regiaoData.regioes[0]]);
            }
          }
          setMensagemRegiao('✅ Região cadastrada com sucesso!');
        } else {
          setMensagemRegiao('❌ Erro ao cadastrar região.');
        }
      } catch {
        setMensagemRegiao('❌ Erro ao cadastrar região.');
      }
    }
    setRegiao({ nome: '' });
  };

  const handleCulturaSubmit = async (e) => {
    e.preventDefault();
    
    if (editCulturaId) {
      // Atualizar cultura existente
      try {
        const res = await fetch(`${API_BASE_URL}/culturas/update`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editCulturaId,
            nome: cultura.nome
          })
        });
        if (res.ok) {
          setCulturas(culturas.map(c => (c.id === editCulturaId ? { ...c, nome: cultura.nome } : c)));
          setMensagemCultura('✅ Cultura atualizada com sucesso!');
          setEditCulturaId(null);
        } else {
          setMensagemCultura('❌ Erro ao atualizar cultura.');
        }
      } catch {
        setMensagemCultura('❌ Erro ao atualizar cultura.');
      }
    } else {
      // Criar nova cultura
      try {
        const res = await fetch(`${API_BASE_URL}/culturas/add`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nome: cultura.nome
          })
        });
        if (res.ok) {
          const result = await res.json();
          // Buscar a cultura recém cadastrada pelo id retornado
          if (result && result.productId) {
            const resCultura = await fetch(`${API_BASE_URL}/culturas/${result.productId}`);
            const culturaData = await resCultura.json();
            if (culturaData && Array.isArray(culturaData.culturas) && culturaData.culturas.length > 0) {
              setCulturas([...culturas, culturaData.culturas[0]]);
            }
          }
          setMensagemCultura('✅ Cultura cadastrada com sucesso!');
        } else {
          setMensagemCultura('❌ Erro ao cadastrar cultura.');
        }
      } catch {
        setMensagemCultura('❌ Erro ao cadastrar cultura.');
      }
    }
    setCultura({ nome: '' });
  };

  const handleEditRegiao = (id) => {
    const r = regioes.find(r => r.id === id);
    setRegiaoEdit({ ...r });
    setEditRegiaoId(id);
    setMensagemRegiao(null);
  };

  const handleDeleteRegiao = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/regioes/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      if (res.ok) {
        setRegioes(regioes.filter(r => r.id !== id));
        setMensagemRegiao('✅ Região removida com sucesso!');
        if (editRegiaoId === id) {
          setEditRegiaoId(null);
          setRegiaoEdit(null);
        }
      } else {
        setMensagemRegiao('❌ Erro ao remover região.');
      }
    } catch {
      setMensagemRegiao('❌ Erro ao remover região.');
    }
  };

  const handleRegiaoEditChange = e => {
    setRegiaoEdit({ ...regiaoEdit, [e.target.name]: e.target.value });
  };

  const handleRegiaoEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/regioes/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: editRegiaoId,
          nome: regiaoEdit.nome
        })
      });
      if (res.ok) {
        setRegioes(regioes.map(r => r.id === editRegiaoId ? { ...regiaoEdit, id: editRegiaoId } : r));
        setEditRegiaoId(null);
        setRegiaoEdit(null);
        setMensagemRegiao('✅ Região atualizada com sucesso!');
      } else {
        setMensagemRegiao('❌ Erro ao atualizar região.');
      }
    } catch {
      setMensagemRegiao('❌ Erro ao atualizar região.');
    }
  };

  const handleEditCultura = (id) => {
    const c = culturas.find(c => c.id === id);
    setCulturaEdit({ ...c });
    setEditCulturaId(id);
    setMensagemCultura(null);
  };

  const handleDeleteCultura = async (id) => {
    try {
      const res = await fetch(`${API_BASE_URL}/culturas/delete`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id })
      });
      if (res.ok) {
        setCulturas(culturas.filter(c => c.id !== id));
        setMensagemCultura('✅ Cultura removida com sucesso!');
        if (editCulturaId === id) {
          setEditCulturaId(null);
          setCulturaEdit(null);
        }
      } else {
        setMensagemCultura('❌ Erro ao remover cultura.');
      }
    } catch {
      setMensagemCultura('❌ Erro ao remover cultura.');
    }
  };

  const handleCulturaEditChange = e => {
    setCulturaEdit({ ...culturaEdit, [e.target.name]: e.target.value });
  };

  const handleCulturaEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE_URL}/culturas/update`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: editCulturaId,
          nome: culturaEdit.nome
        })
      });
      if (res.ok) {
        setCulturas(culturas.map(c => c.id === editCulturaId ? { ...culturaEdit, id: editCulturaId } : c));
        setEditCulturaId(null);
        setCulturaEdit(null);
        setMensagemCultura('✅ Cultura atualizada com sucesso!');
      } else {
        setMensagemCultura('❌ Erro ao atualizar cultura.');
      }
    } catch {
      setMensagemCultura('❌ Erro ao atualizar cultura.');
    }
  };

  return (
    <div className="cadastro-produtor-container">
      <h2>Cadastro de Região e Cultura</h2>
      <div className="cadastro-form" style={{display: 'flex', gap: 32, flexWrap: 'wrap', alignItems: 'flex-start'}}>
        {/* Coluna Região */}
        <div style={{flex: 1, minWidth: 320, maxWidth: 500}}>
          <form onSubmit={handleRegiaoSubmit} style={{ marginBottom: 32 }}>
            <fieldset>
              <legend>Dados da Região</legend>
              <label htmlFor="regiao_nome">Nome da Região</label>
              <input id="regiao_nome" name="nome" value={regiao.nome} onChange={handleRegiaoChange} required />
            </fieldset>
            <button type="submit" className="btn-cadastrar">{editRegiaoId ? 'Salvar' : 'Cadastrar Região'}</button>
            {mensagemRegiao && <p className="mensagem-sucesso">{mensagemRegiao}</p>}
          </form>
          {/* Tabela de regiões cadastradas */}
          <div style={{width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', border: '1px solid #e0e0e0', padding: 24, marginBottom: 32}}>
            <h3>Regiões Cadastradas</h3>
            <div style={{width: '100%', overflowX: 'auto'}}>
              <table style={{width: '100%', maxWidth: '100%', borderCollapse: 'collapse', tableLayout: 'auto'}}>
                <thead>
                  <tr style={{ background: '#f7fafc' }}>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {regioes.map(r => (
                    editRegiaoId === r.id ? (
                      <tr key={r.id} style={{ background: '#f0f4f8' }}>
                        <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                          <input name="nome" value={regiaoEdit.nome} onChange={handleRegiaoEditChange} style={{width: '100%'}} />
                        </td>
                        <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0', textAlign: 'center' }}>
                          <button onClick={handleRegiaoEditSubmit} className="btn-acao" style={{marginRight: 8}}>Salvar</button>
                          <button onClick={() => { setEditRegiaoId(null); setRegiaoEdit(null); }} className="btn-acao excluir">Cancelar</button>
                        </td>
                      </tr>
                    ) : (
                      <tr key={r.id} style={{ background: '#fff' }}>
                        <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{r.nome}</td>
                        <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
                          <button onClick={() => handleEditRegiao(r.id)} className="btn-acao" style={{marginRight: 8}}>Editar</button>
                          <button onClick={() => handleDeleteRegiao(r.id)} className="btn-acao excluir">Excluir</button>
                        </td>
                      </tr>
                    )
                  ))}
                  {regioes.length === 0 && (
                    <tr><td colSpan={2} style={{textAlign: 'center', color: '#888'}}>Nenhuma região cadastrada.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Coluna Cultura */}
        <div style={{flex: 1, minWidth: 320, maxWidth: 500}}>
          <form onSubmit={handleCulturaSubmit} style={{ marginBottom: 32 }}>
            <fieldset>
              <legend>Dados da Cultura</legend>
              <label htmlFor="cultura_nome">Nome da Cultura</label>
              <input id="cultura_nome" name="nome" value={cultura.nome} onChange={handleCulturaChange} required />
            </fieldset>
            <button type="submit" className="btn-cadastrar">{editCulturaId ? 'Salvar' : 'Cadastrar Cultura'}</button>
            {mensagemCultura && <p className="mensagem-sucesso">{mensagemCultura}</p>}
          </form>
          {/* Tabela de culturas cadastradas */}
          <div style={{width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #0001', border: '1px solid #e0e0e0', padding: 24, marginBottom: 32}}>
            <h3>Culturas Cadastradas</h3>
            <div style={{width: '100%', overflowX: 'auto'}}>
              <table style={{width: '100%', maxWidth: '100%', borderCollapse: 'collapse', tableLayout: 'auto'}}>
                <thead>
                  <tr style={{ background: '#f7fafc' }}>
                    <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Nome</th>
                    <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #e2e8f0' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {culturas.map(c => (
                    editCulturaId === c.id ? (
                      <tr key={c.id} style={{ background: '#f0f4f8' }}>
                        <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>
                          <input name="nome" value={culturaEdit.nome} onChange={handleCulturaEditChange} style={{width: '100%'}} />
                        </td>
                        <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0', textAlign: 'center' }}>
                          <button onClick={handleCulturaEditSubmit} className="btn-acao" style={{marginRight: 8}}>Salvar</button>
                          <button onClick={() => { setEditCulturaId(null); setCulturaEdit(null); }} className="btn-acao excluir">Cancelar</button>
                        </td>
                      </tr>
                    ) : (
                      <tr key={c.id} style={{ background: '#fff' }}>
                        <td style={{ padding: '12px', borderBottom: '1px solid #e2e8f0' }}>{c.nome}</td>
                        <td style={{ padding: '12px', textAlign: 'center', borderBottom: '1px solid #e2e8f0' }}>
                          <button onClick={() => handleEditCultura(c.id)} className="btn-acao" style={{marginRight: 8}}>Editar</button>
                          <button onClick={() => handleDeleteCultura(c.id)} className="btn-acao excluir">Excluir</button>
                        </td>
                      </tr>
                    )
                  ))}
                  {culturas.length === 0 && (
                    <tr><td colSpan={2} style={{textAlign: 'center', color: '#888'}}>Nenhuma cultura cadastrada.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Fim das colunas */}
      </div>
      <div className="info-section">
        <h3>Informações sobre Regiões e Culturas</h3>
        <div className="info-card">
          <h4>🗺️ Regiões</h4>
          <p>As regiões organizam territorialmente os povoados e permitem análises geográficas da produção agrícola.</p>
        </div>
        <div className="info-card">
          <h4>🌾 Culturas Agrícolas</h4>
          <p>Cadastre todas as culturas produzidas no município: fumo, mandioca, milho, feijão, etc. Isso permitirá o controle preciso da produção.</p>
        </div>
        <div className="info-card">
          <h4>📈 Produção por Cultura</h4>
          <p>Com as culturas cadastradas, será possível registrar a produção de cada família por tipo de cultura e gerar relatórios detalhados.</p>
        </div>
      </div>
    </div>
  );
}
